import type {
  AdminProgrammeOverview,
  AdminProgrammeOverviewResponse,
  UpdateProgrammeStatusBody,
} from '@sparkapp/shared-types';
import { apiRequest } from './apiClient';

type Envelope<T> = { success: true; data: T };

export const programmeApi = {
  async getOverview(): Promise<AdminProgrammeOverviewResponse> {
    return (await apiRequest<Envelope<AdminProgrammeOverviewResponse>>('/v2/admin/programme')).data;
  },

  async changeStatus(slug: string, body: UpdateProgrammeStatusBody): Promise<AdminProgrammeOverview> {
    return (
      await apiRequest<Envelope<AdminProgrammeOverview>>(`/v2/admin/programme/${slug}/status`, {
        method: 'PATCH',
        body,
      })
    ).data;
  },
};
